import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

const PatientLayout = () => {
  return (
    <Box minHeight={"100%"} minWidth={"100%"}>
      <Outlet />
    </Box>
  );
};

export default PatientLayout;
